import { __awaiter, __generator, __assign } from '../../node_modules/tslib/tslib.es6.js';
import { styled, Grid, useTheme, Dialog, Slider } from '@mui/material';
import React, { useState, useCallback, useEffect } from 'react';
import Cropper from 'react-easy-crop';
import { PLACEHOLDER_GREEN_IMAGE } from '../../utils/constants/Constants.js';
import { AppButton } from '../AppButton/index.js';

var cropWindow = {
    width: 400,
    height: 360,
};
var CropperContainer = styled('div')({
    width: cropWindow.width,
    padding: 25,
    '.crop': {
        position: 'relative',
        width: '100%',
        height: cropWindow.height,
        background: '#fff',
        borderRadius: 10,
        overflow: 'hidden',
    },
    '.control': {
        padding: '15px 0 0 10px',
        display: 'flex',
        alignItems: 'center',
    },
});
var LoadingContainer = styled(Grid, {
    shouldForwardProp: function (prop) { return !['aspectRatio'].includes(prop.toString()); },
})(function (_a) {
    var aspectRatio = _a.aspectRatio;
    return ({
        width: cropWindow.width,
        height: cropWindow.height,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        img: {
            aspectRatio: "".concat(aspectRatio),
            overflow: 'hidden',
        },
    });
});
var ImageCropper = function (_a) {
    var open = _a.open, setOpen = _a.setOpen, file = _a.file, fileTypeToUse = _a.fileTypeToUse, cropperProps = _a.cropperProps, onFileChange = _a.onFileChange;
    var theme = useTheme();
    var _b = useState(''), imageSrc = _b[0], setImageSrc = _b[1];
    var _c = useState({ x: 0, y: 0 }), crop = _c[0], setCrop = _c[1];
    var _d = useState(null), croppedAreaPixels = _d[0], setCroppedAreaPixels = _d[1];
    var _e = useState(1), zoom = _e[0], setZoom = _e[1];
    var onCropComplete = useCallback(function (_croppedArea, croppedAreaPixels) {
        setCroppedAreaPixels(croppedAreaPixels);
    }, []);
    var cropIt = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var croppedImage, newFileEnding, newFileName, newFile, e_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!file) return [3 /*break*/, 4];
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, getCroppedImg(imageSrc, croppedAreaPixels, fileTypeToUse || (file === null || file === void 0 ? void 0 : file.type))];
                case 2:
                    croppedImage = _b.sent();
                    newFileEnding = (_a = fileTypeToUse === null || fileTypeToUse === void 0 ? void 0 : fileTypeToUse.split('/')) === null || _a === void 0 ? void 0 : _a[1];
                    newFileName = newFileEnding // need to replace old file ending with new file ending
                        ? "".concat(file.name.substring(0, file.name.lastIndexOf('.')), ".").concat(newFileEnding)
                        : file.name;
                    newFile = new File([croppedImage], newFileName, {
                        type: fileTypeToUse || (file === null || file === void 0 ? void 0 : file.type),
                    });
                    onFileChange(newFile);
                    setOpen(false);
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _b.sent();
                    console.error('error cropping image: ', e_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [imageSrc, croppedAreaPixels, file, onFileChange, setOpen]);
    //   const moveCrop = (x: number, y: number) => {
    //     setCrop({ x: crop.x + x, y: crop.y + y });
    //   };
    useEffect(function () {
        setCrop({ x: 0, y: 0 });
    }, [imageSrc]);
    useEffect(function () {
        var initImage = function () { return __awaiter(void 0, void 0, void 0, function () {
            var imageDataUrl;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, readFile(file)];
                    case 1:
                        imageDataUrl = _a.sent();
                        setImageSrc(imageDataUrl);
                        return [2 /*return*/];
                }
            });
        }); };
        if (file) {
            initImage();
        }
    }, [file]);
    return (React.createElement(Dialog, { open: open, onClose: function () {
            setOpen(false);
        }, maxWidth: "lg" },
        React.createElement(CropperContainer, null, imageSrc ? (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "crop", onKeyDown: function (e) {
                    // eslint-disable-next-line no-console
                    console.log(e);
                } },
                React.createElement(Cropper, __assign({ image: imageSrc, crop: crop, zoom: zoom, onCropChange: setCrop, onZoomChange: setZoom, onCropComplete: onCropComplete, restrictPosition: false, showGrid: false }, cropperProps, { minZoom: 0.5 }))),
            React.createElement("div", { className: "control" },
                React.createElement("div", { style: { flex: 1, marginRight: 30 } },
                    React.createElement(Slider, { value: zoom, sx: function (theme) { return ({
                            color: theme.palette.primary.main,
                        }); }, min: 0, max: 3, step: 0.1, "aria-labelledby": "Zoom", classes: {}, onChange: function (e, zoom) { return setZoom(zoom); } })),
                React.createElement("div", null,
                    React.createElement(AppButton, { invertStyle: true, onClick: cropIt, sx: {
                            fontFamily: 'Poppins',
                            fontSize: '14px',
                            fontWeight: 600,
                            backgroundColor: theme.palette.primary.main,
                            border: "1px solid ".concat(theme.palette.primary.main),
                            '&:hover': {
                                backgroundColor: theme.palette.primary.main,
                            },
                        } }, "Crop"))))) : (React.createElement(LoadingContainer, { aspectRatio: cropperProps.aspect },
            React.createElement("img", { src: PLACEHOLDER_GREEN_IMAGE['1X1'], alt: "loading-placeholder" }))))));
};
var readFile = function (file) {
    return new Promise(function (resolve) {
        var reader = new FileReader();
        reader.addEventListener('load', function () { return resolve(reader.result); }, false);
        reader.readAsDataURL(file);
    });
};
var createImage = function (url) {
    return new Promise(function (resolve, reject) {
        var image = new Image();
        image.addEventListener('load', function () { return resolve(image); });
        image.addEventListener('error', function (error) { return reject(error); });
        image.setAttribute('crossOrigin', 'anonymous'); // needed to avoid cross-origin issues on CodeSandbox
        image.src = url;
    });
};
var getCroppedImg = function (imageSrc, pixelCrop, type) { return __awaiter(void 0, void 0, void 0, function () {
    var image, canvas, ctx;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, createImage(imageSrc)];
            case 1:
                image = _a.sent();
                canvas = document.createElement('canvas');
                ctx = canvas.getContext('2d');
                if (!ctx) {
                    return [2 /*return*/, null];
                }
                canvas.width = pixelCrop.width;
                canvas.height = pixelCrop.height;
                ctx.fillStyle = '#ffffff00';
                ctx.fillRect(0, 0, canvas.width, canvas.height);
                ctx.drawImage(image, pixelCrop.x, pixelCrop.y, pixelCrop.width, pixelCrop.height, 0, 0, pixelCrop.width, pixelCrop.height);
                // As a blob
                return [2 /*return*/, new Promise(function (resolve) {
                        canvas.toBlob(function (file) {
                            resolve(file);
                        }, type);
                    })];
        }
    });
}); };

export { ImageCropper };
//# sourceMappingURL=ImageCropper.js.map
